<template>
  <page>
    <div :load="doInit">
      <form data-vv-scope="printForm">
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Report Type</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
        <v-card>
          <!-- <v-toolbar dense color="grey lighten-3" flat>
            <v-toolbar-title>Type of Report</v-toolbar-title>
          </v-toolbar> -->
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-autocomplete
                    :items="typeOfReports"
                    v-model="printForm.typeOfReport"
                    :label="printLabel.typeOfReport"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('printForm.typeOfReport')"
                    data-vv-name="printForm.typeOfReport"
                    :data-vv-as="printLabel.typeOfReport"
                    @change="clearForm()"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <v-spacer class="mt-2"></v-spacer>
                <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
        <v-card>
          <!-- <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-filter</v-icon>
              <v-toolbar-title>Filters</v-toolbar-title>
          </v-toolbar> -->
          <!-- <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-filter</v-icon>
              <v-toolbar-title>Filters</v-toolbar-title>
           </v-toolbar> -->
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6 v-show="printForm.typeOfReport === 'P'">
                  <cal-picker
                    v-model="printForm.enteredOn"
                    :label="printLabel.enteredOn"
                    :error-messages="errors.collect('printForm.enteredOn')"
                    :data-vv-as="printLabel.enteredOn"
                    data-vv-name="printForm.enteredOn"
                    v-validate="validatePrint"
                  ></cal-picker>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    readonly
                    v-model="printForm.branch"
                    :label="printLabel.branch"
                    :error-messages="errors.collect('printForm.branch')"
                    data-vv-name="printForm.branch"
                    :data-vv-as="printLabel.branch"
                    v-validate="'required'"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('branch')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    readonly
                    v-model="printForm.department"
                    :label="printLabel.department"
                    :error-messages="errors.collect('printForm.department')"
                    data-vv-name="printForm.department"
                    :data-vv-as="printLabel.department"
                    v-validate="'required'"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('department')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-show="printForm.typeOfReport === 'P'">
                  <v-text-field
                    v-model="printForm.claimNoFrom"
                    :label="printLabel.claimNoFrom"
                    :error-messages="errors.collect('printForm.claimNoFrom')"
                    data-vv-name="printForm.claimNoFrom"
                    :data-vv-as="printLabel.claimNoFrom"
                    v-validate="validatePrint"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('claimNoFrom')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-show="printForm.typeOfReport === 'P'">
                  <v-text-field
                    v-model="printForm.claimNoTo"
                    :label="printLabel.claimNoTo"
                    :error-messages="errors.collect('printForm.claimNoTo')"
                    data-vv-name="printForm.claimNoTo"
                    :data-vv-as="printLabel.claimNoTo"
                    v-validate="validatePrint"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('claimNoTo')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-show="printForm.typeOfReport === 'R'">
                  <v-autocomplete
                    :items="tranTypes"
                    disabled
                    v-model="printForm.tranType"
                    :label="printLabel.tranType"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('printForm.tranType')"
                    data-vv-name="printForm.tranType"
                    :data-vv-as="printLabel.tranType"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-show="printForm.typeOfReport === 'R'">
                  <v-text-field
                    v-model="printForm.docNo"
                    :label="printLabel.docNo"
                    :error-messages="errors.collect('printForm.docNo')"
                    data-vv-name="printForm.docNo"
                    :data-vv-as="printLabel.docNo"
                    v-validate="validateRePrint"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('docNo')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <v-spacer class="mt-2" v-if="printForm.typeOfReport === 'P'"></v-spacer>
                <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Sort Order</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
        <v-card v-if="printForm.typeOfReport === 'P'">
          <!-- <v-toolbar dense color="grey lighten-3" flat>
            <v-toolbar-title>Sort Order</v-toolbar-title>
          </v-toolbar> -->
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-autocomplete
                    :items="sortOrders"
                    v-model="printForm.sortOrder"
                    :label="printLabel.sortOrder"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('printForm.sortOrder')"
                    data-vv-name="printForm.sortOrder"
                    :data-vv-as="printLabel.sortOrder"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <v-spacer class="mt-2"></v-spacer>
        <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex lg6 xs12>
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              Export To
            </v-btn>
            <!-- <v-btn color="white" disabled>
              <v-icon color="red">PDF</v-icon>
            </v-btn> -->
            <v-btn-toggle dense mandatory v-model="printForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
        <v-dialog v-model="showErrorDialog" width="800px">
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="headline">System Information</div>
                <span class="grey--text">An error occurred.</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-if="messages.length > 0" class="pb-3">
                <v-subheader>Error Details:</v-subheader>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                    {{ error.message }}
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="branchList" width="900px" persistent>
          <branch-help-list v-if="branchHelpList" :menu="clmMenu" @close="doClose" @doAssign="doAssign($event)"></branch-help-list>
        </v-dialog>

        <v-dialog v-model="departmentList" width="900px" persistent>
          <department-help-list v-if="departmentHelpList" :dept="dept" @close="doClose" @doAssign="doAssign($event)"></department-help-list>
        </v-dialog>

        <v-dialog v-model="claimNoList" width="900px" persistent>
          <claim-no-help-list
            v-if="claimNoHelpList"
            :brn="brn"
            :enteredDate="printForm.enteredOn"
            :dept="dept"
            :wClm="wClm"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></claim-no-help-list>
        </v-dialog>

        <v-dialog v-model="docNoList" width="900px" persistent>
          <doc-no-help-list
            v-if="docNoHelpList"
            :brn="brn"
            :dept="dept"
            :tranType="printForm.tranType"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></doc-no-help-list>
        </v-dialog>
      </form>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import BranchHelpList from '@/components/reports/claims/claimRegister/BranchHelpList'
import DepartmentHelpList from './DepartmentHelpList.vue'
import ClaimNoHelpList from './ClaimNoHelpList.vue'
import DocNoHelpList from './DocNoHelpList.vue'
import clone from 'clone'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import addDays from 'date-fns/addDays'
import { reportFormat } from '@/const/report'

export default {
  data() {
    return {
      showErrorDialog: false,
      toogleArray: [false],
      menu: {},
      clmMenu: {},
      mode: '',
      supportedFormat: [],
      submitting: false,
      branchList: false,
      branchHelpList: false,
      departmentList: false,
      departmentHelpList: false,
      claimNoList: false,
      claimNoHelpList: false,
      docNoList: false,
      docNoHelpList: false,
      printLabel: {
        typeOfReport: 'Type of Report',
        enteredOn: 'Entered On',
        branch: 'Branch',
        department: 'Department',
        claimNoFrom: 'Claim No. From',
        claimNoTo: 'Claim No. To',
        sortOrder: 'Sort Order',
        tranType: 'Transaction Type',
        docNo: 'Document No.'
      },
      printForm: {
        typeOfReport: '',
        enteredOn: '',
        branch: '',
        department: '',
        claimNoFrom: '',
        claimNoTo: '',
        sortOrder: '',
        rtranType: '',
        docNo: '',
        branchList: '',
        departmentList: '',
        format: ''
      },
      typeOfReports: [
        { label: 'Print', value: 'P' },
        { label: 'Reprint', value: 'R' }
      ],
      tranTypes: [
        { label: 'X - Creadit Note', value: 'X' },
        { label: 'W - Debit Note', value: 'W' },
        { label: 'Z - Payment Voucher', value: 'Z' },
        { label: 'Y - Receipt', value: 'Y' }
      ],
      sortOrders: [
        { label: 'By Document No.', value: '1' },
        { label: 'By Branch / Document No.', value: '2' }
      ],
      wClm: '',
      brn: '',
      dept: '',
      validatePrint: 'required',
      validateRePrint: '',
      panel: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    displayErrorDialog() {
      return this.messages
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.printForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      this.printForm.typeOfReport = 'P'
      this.printForm.sortOrder = '1'
      if (this.$route.name === 'clmPaytVou') {
        this.printForm.tranType = 'Z'
      } else if (this.$route.name === 'clmReceipt') {
        this.printForm.tranType = 'Y'
      } else if (this.$route.name === 'clmDebitNote') {
        this.printForm.tranType = 'W'
      } else if (this.$route.name === 'clmCreditNote') {
        this.printForm.tranType = 'X'
      }

      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimDoc
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    clearForm() {
      // this.printForm.typeOfReport = ''
      this.resetValidator()
      this.resetMessages()
      this.printForm.enteredOn = ''
      this.printForm.branch = ''
      this.printForm.department = ''
      this.printForm.claimNoFrom = ''
      this.printForm.claimNoTo = ''
      this.printForm.docNo = ''
      // this.printForm.sortOrder = ''
      this.printForm.branchList = ''
      this.printForm.departmentList = ''
      if (this.printForm.typeOfReport === 'P') {
        this.validateRePrint = ''
      } else if (this.printForm.typeOfReport === 'R') {
        this.validateRePrint = 'required'
        this.validatePrint = ''
      }
      // this.printForm.typeOfReport = ''
    },
    async getHelpList(fieldName) {
      var errMsg
      var messages = []
      if (this.printForm.enteredOn === '' && this.printForm.typeOfReport === 'P') {
        messages.push({ message: 'The Entered On field is required', type: 'ERROR' })
      }
      if (this.printForm.branch === '') {
        messages.push({ message: 'The Branch field is required', type: 'ERROR' })
      }
      if (this.printForm.department === '') {
        messages.push({ message: 'The Department field is required', type: 'ERROR' })
      }

      this.brn = this.printForm.branch
      this.dept = this.printForm.department

      switch (fieldName) {
        case 'branch':
          try {
            if (this.$store.state.reports.claimReports.init !== 1) {
              await this.$store.dispatch('claimReportsInit')
            }
            const apiURI = this.$store.state.reports.claimReports.menu.claimRegister
            const result = await this.$http.get(apiURI)
            if (result.data) {
              const { data } = result
              if (data) {
                // return as a menu list
                this.clmMenu = extractMenu(result.data._links)
                if (this.clmMenu) {
                  this.branchList = true
                  this.branchHelpList = true
                  this.mode = 'branch'
                }
              }
            }
          } catch (err) {
            throw err
          }
          break
        case 'department':
          this.departmentList = true
          this.departmentHelpList = true
          this.mode = 'department'
          break
        case 'claimNoFrom':
          if (messages.length > 0) {
            errMsg = { messages }
            this.message(errMsg)
            this.fieldMessage(errMsg)
          } else {
            this.claimNoList = true
            this.claimNoHelpList = true
            this.wClm = 'claimNoFrom'
            this.mode = 'claimNoFrom'
          }
          break
        case 'claimNoTo':
          if (messages.length > 0) {
            errMsg = { messages }
            this.message(errMsg)
            this.fieldMessage(errMsg)
          } else {
            this.claimNoList = true
            this.claimNoHelpList = true
            this.wClm = 'claimNoTo'
            this.mode = 'claimNoTo'
          }
          break
        case 'docNo':
          if (messages.length > 0) {
            errMsg = { messages }
            this.message(errMsg)
            this.fieldMessage(errMsg)
          } else {
            this.docNoList = true
            this.docNoHelpList = true
            this.wClm = 'docNo'
            this.mode = 'docNo'
          }
          break
        default:
          this.$snotify.error('Field Name Not Found!')
      }
    },
    doAssign(Obj) {
      if (Obj.from) {
        let from = Obj.from
        switch (from) {
          case 'claimNoFrom':
            this.printForm.claimNoFrom = []
            this.printForm.claimNoFrom = Obj.selectedItems.toString()
            break
          case 'claimNoTo':
            this.printForm.claimNoTo = []
            this.printForm.claimNoTo = Obj.selectedItems.toString()
            break
          case 'docNo':
            this.printForm.docNo = []
            this.printForm.docNo = Obj.selectedItems.toString()
            break
          default:
            this.$snotify.error('No Assignment Returned!')
        }
      } else {
        switch (this.mode) {
          case 'branch':
            this.printForm.branch = []
            this.printForm.branch = Obj.finalSelectedItems.toString()
            this.printForm.branchList = Obj.finalSelectedItems.toString()
            break
          case 'department':
            this.printForm.department = []
            this.printForm.department = Obj.finalSelectedItems.toString()
            this.printForm.departmentList = Obj.finalSelectedItems.toString()
            break
          default:
            this.$snotify.error('No Mode Returned!')
        }
      }
    },
    doClose() {
      this.branchList = false
      this.branchHelpList = false
      this.departmentList = false
      this.departmentHelpList = false
      this.claimNoList = false
      this.claimNoHelpList = false
      this.docNoList = false
      this.docNoHelpList = false
    },
    doExport() {
      this.$validator.validateAll('printForm').then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true

          if (this.printForm.enteredDate !== null && this.printForm.enteredDate !== '') {
            this.printForm.enteredOnDateFrom = formatDisplayDateTime2(removeTime(this.printForm.enteredDate - 1))
            this.printForm.enteredOnDateTo = formatDisplayDateTime2(removeTime(addDays(this.printForm.enteredDate, 1)))
          }

          let messageFilters
          messageFilters = clone(this.printForm)
          await this.$http.post(apiURI, messageFilters)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    BranchHelpList,
    DepartmentHelpList,
    ClaimNoHelpList,
    DocNoHelpList
  },
  props: {
    tranType: {
      type: String,
      default: ''
    }
  }
}
</script>
